/** Compatibility export; the business domain owns this implementation. */
export { EnumBsrSorting } from '@domains/research/shared';
